export class Time {
  public hour: number;
  public minute: number;

  constructor(hour: number, minute: number) {
    this.hour = hour;
    this.minute = minute;
  }

  public static isTime(value: any): value is Time {
    return value != null && typeof value.hour === 'number' && typeof value.minute === 'number';
  }

  public static toString(time?: Time, separator: string = ':', padTime: boolean = false): string {
    const pad: number = padTime ? 2 : 1; // Create var to avoid nested ternary operations
    return time && time.hour >= 0 && time.hour < 24 && time.minute >= 0 && time.minute < 60
      ? `${(time.hour + '').padStart(pad, '0')}${separator}${(time.minute + '').padStart(pad, '0')}`
      : undefined;
  }
}
